import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SchemaValidationBadges } from '../../schema-view';
import { Badge } from '@criteria-labs/react';
function RequiredBadge() {
    return (_jsx(Badge, { className: "ml-2", color: "red", children: "required" }));
}
function AttributeHeadingPrefix({ entity, parents }) {
    const arrayIndexPrefix = (location) => {
        if (location === '/items' || location.startsWith('/items/')) {
            return '[]' + arrayIndexPrefix(location.slice('/items'.length));
        }
        else {
            return '';
        }
    };
    let prefix = '';
    for (const parent of parents) {
        prefix += arrayIndexPrefix(parent.entity.attributesContainerSchemaLocation);
        if (prefix.length > 0) {
            prefix += '.';
        }
        prefix += parent.attribute.name;
    }
    prefix += arrayIndexPrefix(entity.attributesContainerSchemaLocation);
    if (prefix.length > 0) {
        prefix += '.';
    }
    if (prefix.length > 0) {
        return _jsx("span", { className: "font-mono text-zinc-400 dark:text-white/40", children: prefix });
    }
    return null;
}
export function AttributeHeading({ entity, attribute, parents }) {
    return (_jsxs("h4", { className: "text-xs font-medium leading-6 text-zinc-950 dark:text-white", children: [_jsx(AttributeHeadingPrefix, { entity: entity, parents: parents }), _jsx("span", { className: "mr-2 font-mono font-semibold", children: attribute.name }), _jsx(SchemaValidationBadges, { schema: attribute.valueSchema }), !attribute.optional && _jsx(RequiredBadge, {})] }));
}
